import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";

export type Product = {
  id: string;
  display_name: string;
};

type UseMissionProductsProps<T> = {
  mapper?: (data: Product[]) => T;
};

export const useMissionProducts = <T = Product[]>({
  mapper = ((data: Product[]) => data as unknown as T),
}: UseMissionProductsProps<T> = {}) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ["mission-products"],
    queryFn: () => privateAxios.get("/tmais/products"),
    select: (response: { data?: { data?: Product[] } }) =>
      mapper(response.data?.data ?? []),
  });
};
